import { MessageState } from './types';
import { ReduxAction } from '../core';

const initialState: MessageState = {};

export function messageReducer(state: MessageState = initialState, action: ReduxAction<any>): MessageState {
  switch (action.type) {
    default:
      return state;
  }
}
